<template>
  <div>
    <p class="body-2 text--secondary mb-4">
      Informe o SLA (limite de aging dos tickets de instalação) do provedor
      <strong>{{ provedor.nome }}</strong>.
    </p>

    <v-text-field
      v-model="sla"
      type="number"
      min="1"
      step="1"
      label="SLA (minutos)"
      placeholder="Ex.: 480"
      suffix="min"
      outlined
      dense
      persistent-hint
      :hint="hintHoras"
      :rules="[validarSla]"
    />

    <div class="container-botoes mt-4">
      <button
        class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize"
        type="button"
        :disabled="salvando || !slaValido"
        @click="salvar"
      >
        {{ salvando ? 'Salvando...' : 'Salvar' }}
      </button>
      <button
        v-if="slaId"
        class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default primary--text text-capitalize"
        type="button"
        :disabled="salvando"
        @click="remover"
      >
        Remover SLA
      </button>
      <button
        class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize"
        type="button"
        :disabled="salvando"
        @click="$emit('fechar')"
      >
        Cancelar
      </button>
    </div>

    <SGPLoadingComponent v-if="salvando" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { formatarSlaHoras } from '../helpers/slaHelper'

export default {
  name: 'SlaProvedorComponent',

  props: {
    provedor: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      sla: this.provedor?.sla_instalacao?.sla ?? '',
      salvando: false
    }
  },

  computed: {
    slaId () {
      return this.provedor?.sla_instalacao?.id ?? null
    },

    slaNumero () {
      return Number(this.sla)
    },

    slaValido () {
      return this.sla !== '' && this.sla !== null &&
        Number.isInteger(this.slaNumero) && this.slaNumero >= 1
    },

    hintHoras () {
      return this.slaValido ? `= ${formatarSlaHoras(this.slaNumero)}` : 'Valor em minutos (ex.: 8h = 480)'
    }
  },

  methods: {
    ...mapActions('ctrlProvedores', ['salvarSlaProvedor', 'removerSlaProvedor']),

    validarSla () {
      if (this.sla === '' || this.sla === null) return true
      return this.slaValido || 'Informe um número inteiro maior ou igual a 1'
    },

    async salvar () {
      if (!this.provedor?.id || !this.slaValido || this.salvando) return

      this.salvando = true
      try {
        await this.salvarSlaProvedor({
          ctrl_provedor_id: this.provedor.id,
          sla: this.slaNumero
        })
        this.$emit('salvo')
      } catch (error) {
        console.error('Erro ao salvar SLA do provedor:', error)
      } finally {
        this.salvando = false
      }
    },

    async remover () {
      if (!this.slaId || this.salvando) return

      this.salvando = true
      try {
        await this.removerSlaProvedor(this.slaId)
        this.$emit('salvo')
      } catch (error) {
        console.error('Erro ao remover SLA do provedor:', error)
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>
